/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Ad_CcprjInputs */

const en_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import AD Project`)
};

const fr_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet d'importation AD`)
};

const de_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Projekt importieren`)
};

const it_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa progetto AD`)
};

const ru_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта AD`)
};

const es_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar proyecto AD`)
};

const zh_cn2_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入 AD 项目`)
};

const ja_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADプロジェクトをインポートする`)
};

const hi_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD प्रोजेक्ट आयात करें`)
};

const pt_pt2_import_ad_ccprj = /** @type {(inputs: Import_Ad_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de Importação de Anúncios`)
};

/**
* | output |
* | --- |
* | "Import AD Project" |
*
* @param {Import_Ad_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_ad_ccprj = /** @type {((inputs?: Import_Ad_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Ad_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_ad_ccprj(inputs)
	if (locale === "de") return de_import_ad_ccprj(inputs)
	if (locale === "it") return it_import_ad_ccprj(inputs)
	if (locale === "ru") return ru_import_ad_ccprj(inputs)
	if (locale === "es") return es_import_ad_ccprj(inputs)
	if (locale === "zh-CN") return zh_cn2_import_ad_ccprj(inputs)
	if (locale === "ja") return ja_import_ad_ccprj(inputs)
	if (locale === "hi") return hi_import_ad_ccprj(inputs)
	if (locale === "pt-PT") return pt_pt2_import_ad_ccprj(inputs)
	return en_import_ad_ccprj(inputs)
});